import { Button, Carousel, Input, Typography } from "antd";
import styled from "styled-components";

const { Search } = Input;
const { Title } = Typography;

export const StyledCarousal = styled(Carousel)`
  background-image: url("blue.png");
  height: 95vh;
  margin-right: 10px;
  margin-top: 15px;
  margin-bottom: 20px;
  border-radius: 2%;
`;

export const StyledSearchField = styled(Search)`
  &:where(.css-dev-only-do-not-override-1ck3jst).ant-input-search
    > .ant-input-group
    > .ant-input-group-addon:last-child
    .ant-input-search-button {
    padding-bottom: 0;
    border-start-start-radius: 0;
    border-start-end-radius: 0px;
    border-end-end-radius: 0px;
    border-end-start-radius: 0;
    box-shadow: none;
    color: black;
    background-color: orange;
  }
  &.ant-input-search
    :where(.css-dev-only-do-not-override-1ck3jst).ant-input-group
    .ant-input-affix-wrapper:not(:last-child) {
    border-radius: 0px;
  }
`;

export const StyledLoginButton = styled(Button)`
  width: 100%;
  &&.ant-btn-primary {
    background-color: #de283b;
    border-color: #de283b;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      background-color: white;
      border-color: #de283b;
      color: #de283b;
    }
  }
`;

export const StyledTitle = styled(Title)`
  &:where(.css-dev-only-do-not-override-xu9wm8).ant-typography,
  div:where(.css-dev-only-do-not-override-xu9wm8).ant-typography-h2,
  div:where(.css-dev-only-do-not-override-xu9wm8).ant-typography-h2 > textarea,
  :where(.css-dev-only-do-not-override-xu9wm8).ant-typography h2 {
    font-size: 42px;
    text-align: left;
    margin-left: 20px;
    margin-top: 70px;
    color: white;
  }
`;
